export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter(
    (item) => item[1].active === 1
  );
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

export function hideNumber(senderNumber, user, channel, author) {
  if (
    senderNumber === user &&
    ['telegram', 'tgcomm', 'max'].includes(channel)
  ) {
    let idRandom = getRandomInt(1000, 9999);
    return `@id*****${idRandom}`;
  }
  if (senderNumber === user) {
    let template = '79*****';
    let numberToSpace = [0, 3, 6, 8];

    let regular = /((8|7|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{6,16}/g;
    let resultMatch = author.match(regular);

    let hidedNumber = '';

    if (resultMatch) {
      resultMatch = resultMatch[0].replaceAll(/[-() +]/g, '');

      hidedNumber = Array.from(resultMatch).reduceRight(
        function (ctx, char) {
          var isDigit = char >= '0' && char <= '9';
          var offset = ctx.offset + (isDigit ? 1 : 0);
          var filteredChar = isDigit
            ? offset >= 4 && offset < 9
              ? '*'
              : char
            : char;
          var filtered = filteredChar + ctx.filtered;
          return { offset: offset, filtered: filtered };
        },
        { offset: -1, filtered: '' }
      ).filtered;
    }

    let fullNumber =
      template.slice(
        0,
        11 - (hidedNumber.length < 11 ? hidedNumber.length : 11)
      ) + (hidedNumber ? hidedNumber : getRandomInt(1000, 9999));

    let resultNumberMask = Array.from(fullNumber).reduce((acc, el, index) => {
      return acc + el + (numberToSpace.includes(index) ? ' ' : '');
    }, '');

    return `+${resultNumberMask}`;
  }

  if (senderNumber.startsWith('7') && senderNumber.length === 11) {
    let numberToSpace = [0, 3, 6, 8];

    let phone = Array.from(senderNumber).reduce(function (ctx, char, index) {
      let isDigit = char >= '0' && char <= '9';

      let filteredChar = isDigit
        ? index >= 2 && index < 7
          ? '*'
          : char
        : char;
      return ctx + filteredChar + (numberToSpace.includes(index) ? ' ' : '');
    }, '');

    return `+${phone}`;
  } else if (senderNumber) {
    let id = senderNumber.slice(-4);
    return `@id*****${id}`;
  } else return '';
}

export const formatPhoneNumber = (phone = '', delimiter = ' ') => {
  let res = '';

  if (!phone) {
    return res;
  }

  let phoneNumber = phone.startsWith('+') ? phone : `+${phone}`;
  for (let i = 0; i < phoneNumber.length; i++) {
    const char = phoneNumber[i];

    if (phoneNumber.includes('+7') || phoneNumber.includes('+8')) {
      if ([0, 2, 3, 5, 6, 8, 10, 11].includes(i)) {
        res += char;
      } else if ([1, 4].includes(i)) {
        res += `${char} `;
      } else if ([7, 9].includes(i)) {
        res += `${char}${delimiter}`;
      }
    }
    // код Молдовы
    else if (phoneNumber.includes('+373')) {
      if ([0, 1, 2, 4, 5, 6, 8, 9, 10, 11].includes(i)) {
        res += char;
      } else if ([3].includes(i)) {
        res += `${char} `;
      } else if ([7].includes(i)) {
        res += `${char}${delimiter}`;
      }
    } else {
      res += char;
    }
  }

  return res;
};
